<template>
  <div class="login-content">
    <div v-click-outside="onClickOutside" class="modal-login">
      <div class="item--title">
        <span class="item--title">
          Registering to this website, accept our Privacy policy.
        </span>
        <span class="item--close" @click="closeModal"
          ><font-awesome-icon
            id="user--btn-icon"
            class="item--close-icon"
            icon="times"
        /></span>
      </div>
      <div class="form-login" @keyup.enter="login">
        <div class="area-input">
          <input
            class="item--input"
            v-model="form.username"
            placeholder="Email"
            type="text"
          />
          <font-awesome-icon class="input--icon" icon="envelope" />
        </div>
        <div class="area-input">
          <input
            class="item--input"
            v-model="form.password"
            placeholder="Password"
            type="password"
          />
          <font-awesome-icon class="input--icon" icon="lock" />
        </div>
        <div class="item--forgot-password" @click="forgotForm()">
          Forgot your Password?
        </div>
      </div>
      <div class="area-btn-login">
        <button class="item--btn btn-login" @click="login">Log in</button>
        <div class="item--register">
          Not a member?
          <strong class="item--signup" @click="signupModal()"> Sign up</strong>
        </div>
      </div>
      <div class="area--rrss">
        <div class="item--rrss">
          <button class="item--btn btn-facebook" @click="loginFacebook">
            Sign In with Facebook
          </button>
          <font-awesome-icon
            color="#ffffff"
            class="rrss--icon rrss--facebook"
            :icon="['fab', 'facebook-f']"
          />
        </div>
        <div class="item--rrss">
          <button
            id="appleid-signin"
            data-type="sign-in"
            data-color="none"
            data-border="false"
            data-border-radius="50"
            data-mode="center-align"
            class="item--btn btn-apple"
          ></button>
          <!-- <font-awesome-icon
            color="#000000"
            :icon="['fab', 'apple']"
          /> -->
        </div>
        <div class="item--rrss">
          <button class="item--btn btn-google" @click="loginGoogle">
            Sign In with Google
          </button>
          <font-awesome-icon
            color="#ffffff"
            class="rrss--icon"
            :icon="['fab', 'google']"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "IthMenuAsside",
  data: () => ({
    watchlistLocal: null,
    watchedLocal: null,
    params: { watchedShows: [], watchlistShows: [] },
    directives: {
      clickOutside: vClickOutside.directive,
    },
    form: { username: "", password: "", email: "", name: "" },
    alert: { color: "", message: "" },
  }),
  computed: mapState(["menuAsside", "user"]),
  methods: {
    onClickOutside(event) {
      if (event.target.className == "login-content") {
        this.$store.commit("DISABLED_MENU");
      } //this.menuAsside != true &&
    },
    closeModal() {
      this.$store.commit("toggleLoginModal");
      this.$store.commit("DISABLED_MENU");
    },
    async login() {
      await this.$Parse.User.logIn(this.form.username, this.form.password)
        .then((response) => {
          if (
            this.user.country != null ||
            this.user.country != response.attributes.country
          )
            if (response.country)
              this.$store.dispatch("SET_COUNTRY", response.country);
            else
              this.$store.dispatch("SET_COUNTRY", response.attributes.country);
          this.alert.color = "#94C659";
          this.alert.message = "Login Successful";
          this.$store.commit("editAlert", this.alert);
          this.$store.commit("DISABLED_MENU");
          this.$store.commit("dataUser", response.attributes);
          this.$store.dispatch("FETCH_CANT_WATCH_WATCHLIST");

          this.saveLocalStorage();
        })
        .catch((response) => {
          this.alert.color = "#EF3D58";
          this.alert.message = response.message;
          this.$store.commit("editAlert", this.alert);
        });
    },
    async loginGoogle() {
      try {
        const googleUser = await this.$gAuth.signIn();
        const GoogleAuth = googleUser.getAuthResponse();
        const user_id = googleUser.getId();
        const name = googleUser.getBasicProfile();
        let authData = {
          authData: {
            id_token: GoogleAuth.id_token,
            id: user_id,
          },
        };
        let current = await this.$Parse.User.logInWith("google", authData);
        if (this.user.country != null || this.user.country != "USA")
          this.$store.dispatch("SET_COUNTRY", "USA");
        this.alert.color = "#94C659";
        this.alert.message = "Login Successful";
        this.$store.commit("editAlert", this.alert);
        this.$store.commit("DISABLED_MENU");
        this.$store.commit("dataUser", current);
        this.$store.dispatch("FETCH_CANT_WATCH_WATCHLIST");
        this.saveLocalStorage();
        let params = { name: name.Ad };
        this.$store.dispatch("SET_USERNAME", params);
        this.isSignIn = this.$gAuth.isAuthorized;
      } catch (error) {
        this.alert.color = "#EF3D58";
        this.alert.message = error.message;
        this.$store.commit("editAlert", this.alert);
        console.error(error);
        return null;
      }
    },
    async loginFacebook() {
      try {
        const user = await this.$Parse.FacebookUtils.logIn();
        if (
          this.user.country != null ||
          this.user.country != user.attributes.country
        )
          this.$store.dispatch("SET_COUNTRY", user.attributes.country);
        else {
          this.$store.dispatch("SET_COUNTRY", "USA");
        }
        this.alert.color = "#94C659";
        this.alert.message = "Login Successful";
        this.$store.commit("editAlert", this.alert);
        this.$store.commit("DISABLED_MENU");
        this.$store.commit("dataUser", user.attributes);
        this.$store.dispatch("FETCH_CANT_WATCH_WATCHLIST");
        let a = this.$store;
        this.saveLocalStorage();
        window.FB.api("/me", function (response) {
          a.dispatch("SET_USERNAME", response);
        });
      } catch (error) {
        this.alert.color = "#EF3D58";
        this.alert.message = error.message;
        this.$store.commit("editAlert", this.alert);
      }
    },
    signupModal() {
      this.$store.commit("DISABLED_MENU");
      this.$store.commit("toggleRegisterModal");
    },
    forgotForm() {
      this.$store.commit("DISABLED_MENU");
      this.$store.commit("toggleForgotModal");
    },
    saveLocalStorage() {
      this.watchlistLocal = JSON.parse(
        localStorage.getItem("OTT/Watchlist/Guest")
      );
      this.watchedLocal = JSON.parse(localStorage.getItem("OTT/Watched/Guest"));
      if (this.watchlistLocal != null && this.watchlistLocal.length > 0) {
        for (let index = 0; index < this.watchlistLocal.length; index++) {
          this.params.watchlistShows.push(this.watchlistLocal[index].showId);
        }
        this.params.watchlistShows = this.params.watchlistShows.toString();
      }
      if (this.watchedLocal != null && this.watchedLocal.length > 0) {
        for (let index = 0; index < this.watchedLocal.length; index++) {
          this.params.watchedShows.push(this.watchedLocal[index].showId);
        }
        this.params.watchedShows = this.params.watchedShows.toString();
      }

      if (this.params.watchlistShows != "" || this.params.watchedShows != "")
        this.$Parse.Cloud.run("setUserShows", this.params)
          .then(() => {
            localStorage.removeItem("OTT/Watchlist/Guest");
            localStorage.removeItem("OTT/Watched/Guest");
          })
          .catch((error) => {
            console.log(error);
          });
    },
  },
};
</script>

<style scoped>
.login-content {
  background-color: rgba(44, 56, 72, 0.8);
  height: 100vh;
  width: 100vw;
  padding-top: 15vh;
}
.modal-login {
  background-color: #284060;
  height: 500px;
  width: 30vw;
  border-radius: 40px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 50px 122px 75px 250px;
  row-gap: 2%;
  justify-content: space-between;
  padding: 10px 15vh;
  position: relative;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: 3%;
  width: 20px;
  height: 20px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 10px;
}
.item--close-icon {
  font-size: 11px;
  padding-top: 4.2px;
  padding-bottom: 3px;
}
.item--title {
  text-align: center;
  padding-top: 10px;
}
.form-login,
.area-btn-login,
.area--rrss {
  display: flex;
  flex-direction: column;
}

.area--rrss {
  min-height: 250px;
}
.area-input {
  position: relative;
}

.item--input {
  width: 100%;
  height: 40px;
  margin: 7px 0;
  background-color: #375072;
  border-radius: 15px;
  border: none;
  padding-left: 40px;
  box-sizing: border-box;
}
.input--icon {
  position: absolute;
  left: 18px;
  right: 0;
  top: 18px;
  bottom: 0;
}
.item--forgot-password {
  text-align: center;
  margin: 7px 0;
  font-weight: 800;
  cursor: pointer;
}

.item--btn {
  margin: 7px 0;
  border: none;
  border-radius: 20px;
  color: white;
  font-family: Montserrat;
  cursor: pointer;
}
.item--register {
  text-align: center;
}
.btn-login {
  background-color: #ef3d58;
  font-size: 20px;
  font-weight: 600;
  height: 40px;
  width: 100%;
  margin: 10px auto;
}

.item--rrss {
  width: 80%;
  margin: 5px auto;
  position: relative;
}
.btn-facebook {
  background-color: #3b5a99;
  font-size: 15px;
  height: 35px;
  width: 100%;
}

.btn-apple {
  background-color: white;
  height: 35px;
  color: black;
  width: 100%;
  margin: 5px auto;
  font-family: Montserrat;
  font-size: 15px !important;
}
.rrss--icon-apple {
  position: absolute;
  left: 26%;
  top: 12px;
  height: 35px;
  width: 300px;
  color: black;
}
.btn-google {
  background-color: #ea4335;
  font-size: 15px;
  height: 35px;
  width: 100%;
  margin: 5px auto;
}
.rrss--icon {
  position: absolute;
  left: 12px;
  right: 0;
  top: 11px;
  bottom: 0;
  font-size: 1.3em;
  cursor: pointer;
}
.rrss--facebook {
  top: 13px;
}
.item--signup {
  cursor: pointer;
}

.appleid-signin {
  width: 100%;
}

@media (min-width: 1480px) {
  .modal-login {
    height: 50vh;
    width: 20vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1264px) and (max-width: 1400px) {
  .modal-login {
    /* height: 80vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1020px) {
  .modal-login {
    /* height: 60vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .modal-login {
    /* height: 50vh; */
    width: 50vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 4vh;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .modal-login {
    height: 70vh;
    width: 65vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 8vh;
  }
}
@media (max-width: 600px) {
  .modal-login {
    /* height: 75vh; */
    width: 80vw;
    border-radius: 20px;
    margin: 0 auto;
    padding: 10px 2vh;
  }

  .item--close {
    right: 3%;
    top: 6px;
  }
  .item--title {
    margin-top: 12px;
  }
}
</style>
